import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { UserService } from '../../../shared/user.service';

@Component({
  selector: 'app-company-profile-form',
  templateUrl: './company-profile-form.component.html',
  styleUrls: ['./company-profile-form.component.css']
})
export class CompanyProfileFormComponent implements OnInit {
 
  title = "Add Company Profile";
  data: any = {};
  formInvalid: boolean = false;
  c: any = {};
  d: any = {};
  Company_Id: any;
  mode: string;
  Districtlist: any = {};
  Statelist: any = {};
  s: any = {};
  today: any;
  fileToUpload: File;
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) {  }

    ngOnInit() {
      // this.today = new Date().toISOString().split('T')[0];
      this.today = new Date().toISOString().split('T')[0];
  
      this.GetAllData();
      this.route.params.subscribe(params => {
        this.Company_Id = params['Company_Id'];
        this.mode = params['mode'];
  
        if (this.mode == 'View' || this.mode == 'Edit') {
          this.GetCompanyById(this.Company_Id)
        }
      });
  
      if (this.mode == 'View') {
        this.title = "View Company ";
      }
      else if (this.mode == 'Edit') {
        this.title = "Edit Company ";
      }
    }
  
    GetAllData() {
      debugger;
  
      this.data = this.UserService.GetAllDistricts();
      this.data.subscribe(
        (response: any) => {
          this.Districtlist = response.Result;
          console.log("district");
          console.log(this.Districtlist)
        })
      this.data = this.UserService.GetAllStatelist();
      this.data.subscribe(      (response: any) => {
          this.Statelist = response.Result;
        })
    }
  
  imageUploacompnay(file: FileList) {
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpeg|.jpg|.png)$/;
  
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.IS_UploadPath = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.UserService.uploadImageCompany(data);
      x.subscribe(
        (response) => {
  
        }, (error) => {
          let i: any = document.getElementById('Company_Logo_Path');
          i.value = "";
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Company_Logo_Path');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }
  
  
  
  getFeasibilityFUrlAdhara() {
    let imagename = null;
    try {
      imagename = document.getElementById('Company_Logo_Path');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }
  
  
  
  
    SaveCompany(Company: NgForm) {
  
      if (Company.invalid) {
        this.formInvalid = true;
        swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
        return;
      }
  
      else {
  
        Company.value.Company_Logo_Path = this.getFeasibilityFUrlAdhara();
        this.data = this.UserService.PostCompany(Company.value);
        this.data.subscribe(
          (response) => {
            Company.reset();
            Company.resetForm();
            Company.form.markAsPristine();
            Company.form.markAsUntouched();
            swal('Success!', 'Company Added Successfully .', 'success');
            this.router.navigate(['/home/company-profile']);
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  
  
      }
    }
  
    GetCompanyById(Company_Id) {
      debugger;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.UserService.GetByIdCompanyModel(Company_Id);
      this.data.subscribe(
        (response: any) => {
          this.c = response;
  
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    UpdateCompany(Company: NgForm) {
      Company.value.Company_Logo_Path = this.getFeasibilityFUrlAdhara();
      this.data = this.UserService.UpdateComapny(Company.value, this.Company_Id);
      this.data.subscribe(
        (response) => {
          Company.reset();
          Company.resetForm();
          Company.form.markAsPristine();
          Company.form.markAsUntouched();
  
          swal('Success!', 'Company updated Successfully .', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          this.router.navigate(['/home/company-profile']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
  
    Cancel() {
      //this.router.navigate(['/home/district']) ; 
      this.c.Company_Name = '';
      this.c.Company_Adress = '';
      this.c.Adress1 = '';
      this.c.District_Code = '';
      this.c.State_Code = '';
      this.c.Pin_Code = '';
      this.c.Telephone_No = '';
      this.c.Alt_Telephone_No = '';
      this.c.Fax_No = '';
      this.c.Email = '';
      this.c.Cin_No = '';
      this.c.Company_Reg_No = '';
      this.c.Tin_Gst_No = '';
      this.c.Company_Pan_No = '';
      this.c.Company_Website = '';
    }
  
  
  
  
  
  
  }
  
  


// WEBPACK FOOTER //
// ./src/app/ultilities/company-profile/company-profile-form/company-profile-form.component.ts